import _ from 'lodash';
import moment from 'moment';
import set from 'lodash/fp/set';

const ANONYMOUS = {
    first_name: 'Anonymous',
    last_name: '',
    description: '',
    image_url: null,
    linkedin: false,
    linkedin_profile_url: '',
    company: '',
    position: '',
    sortstring: '',
};

export default function (state, action) {
    if (!state) {
        state = {
            loaded: false,
            listed: [],
            indexed: {},
            filter: {
                text: null,
            },
            fetchTime: 0,
            unreadQuestions: 0,
        };
    }

    let previous = state;

    switch (action.type) {
        case 'EVENT_QUESTIONS_LOADED':
            state = Object.assign({}, state, {
                loaded: true,
                listed: action.questions.map((question) => ({
                    ...question,
                    answers: {
                        ...question.answers,
                        data: state.indexed[question.id]?.answers.data,
                    },
                    date_created: moment.utc(question.date_created).toISOString(),
                    lastModified: moment.utc(question.lastModified).toISOString(),
                    lastUpdate: moment.utc(question.lastUpdate).toISOString(),
                })),
                fetchTime: moment(action.fetchTime),
            });
        case 'EVENT_QUESTIONS_MARKED_DELETED':
            if (action.deleted) {
                state = set(
                    'listed',
                    _(state.listed)
                        .reject((question) => _.includes(action.deleted, question.id))
                        .value(),
                    state
                );
            }
            break;
        case 'EVENT_QUESTIONS_SET_FILTER':
            state = Object.assign({}, state, {
                filter: {
                    text: action.text,
                },
            });
            break;
        case 'EVENT_QUESTIONS_ADD':
            state = Object.assign({}, state, {
                fetchTime: moment(action.question.date_created),
                listed: [
                    ...state.listed,
                    {
                        ...action.question,
                        date_created: moment.utc(action.question.date_created).toISOString(),
                        lastModified: moment.utc(action.question.lastModified).toISOString(),
                        lastUpdate: moment.utc(action.question.lastUpdate).toISOString(),
                    },
                ],
            });
            break;
        case 'EVENT_QUESTIONS_UPDATE':
            state = {
                ...state,
                fetchTime: moment(action.lastUpdate),
                indexed: {
                    ...state.indexed,
                    [action.question.id]: {
                        ..._(state).get(`indexed[${action.question.id}]`, {}),
                        ...action.question,
                        answers: _(state).get(`indexed[${action.question.id}].answers`, []),
                        date_created: moment.utc(action.question.date_created).toISOString(),
                        lastModified: moment.utc(action.question.lastModified).toISOString(),
                        lastUpdate: moment.utc(action.question.lastUpdate).toISOString(),
                    },
                },
            };
            state.listed = _.values(state.indexed);
            break;
        case 'EVENT_QUESTIONS_DELETE':
            state = {
                ...state,
                listed: state.listed.filter((question) => question.id != action.questionId),
            };
            break;
        case 'EVENT_QUESTION_SET_ANSWERS':
            if (state.indexed[action.questionId]) {
                state = Object.assign({}, state, {
                    fetchTime: moment(action.fetchTime),
                    indexed: Object.assign({}, state.indexed, {
                        [action.questionId]: Object.assign({}, state.indexed[action.questionId], {
                            answers: Object.assign({}, state.indexed[action.questionId].answers, {
                                _anonimized: false,
                                data: action.answers.map((answer) => ({
                                    ...answer,
                                    date_created: moment.utc(answer.date_created).toISOString(),
                                })),
                                count: action.answers.length,
                                mine: action.mineCount,
                            }),
                        }),
                    }),
                });
                state.listed = _.values(state.indexed);
            } else {
                console.log('question not found: #', action.questionId);
            }
            break;
        case 'EVENT_QUESTION_ADD_ANSWER':
            state = Object.assign({}, state, {
                fetchTime: moment(action.answer.date_created),
                indexed: Object.assign({}, state.indexed, {
                    [action.questionId]: state.indexed[action.questionId]
                        ? Object.assign({}, state.indexed[action.questionId], {
                              answers: Object.assign({}, state.indexed[action.questionId].answers, {
                                  _anonimized: false,
                                  data: [
                                      ...(state.indexed[action.questionId].answers.data || []),
                                      {
                                          ...action.answer,
                                          date_created: moment.utc(action.answer.date_created).toISOString(),
                                      },
                                  ],
                                  count: state.indexed[action.questionId].answers.count + 1,
                                  mine: state.indexed[action.questionId].answers + 1,
                              }),
                          })
                        : null,
                }),
            });
            state.listed = _(state.indexed).values().compact();
            break;
        case 'EVENT_QUESTION_UPDATE_ANSWER':
            state = Object.assign({}, state, {
                indexed: Object.assign({}, state.indexed, {
                    [action.questionId]: state.indexed[action.questionId]
                        ? Object.assign({}, state.indexed[action.questionId], {
                              answers: Object.assign({}, state.indexed[action.questionId].answers, {
                                  _anonimized: false,
                                  data: _(state.indexed[action.questionId].answers.data)
                                      .map((answer) => {
                                          if (answer.id == action.answer.id) {
                                              return action.answer;
                                          }
                                          return answer;
                                      })
                                      .value(),
                              }),
                          })
                        : null,
                }),
            });
            state.listed = _(state.indexed).values().compact().value();
            break;
        case 'EVENT_QUESTION_DELETE_ANSWER':
            if (_.get('state.indexed', '[' + action.questionId + '].answers.data[' + action.answerId + ']')) {
                let answers = _(state.indexed[action.questionId].answers.data)
                    .reject({
                        id: action.answer.id,
                    })
                    .value();
                state = Object.assign({}, state, {
                    [action.questionId]: Object.assign({}, state.indexed[action.questionId], {
                        data: answers,
                        count: state.indexed[action.questionId].answers.count - 1,
                        mine: state.indexed[action.questionId].answers.mine - 1,
                    }),
                });
                state.listed = _(state.indexed).values().compact().value();
            }
            break;
        case 'SESSION_UPDATES':
            state = {
                ...state,
                unreadQuestions: action.eventUpdates.unread_questions,
            };
            break;
        case 'EVENT_QUESTIONS_MARK_AS_READ':
            state = {
                ...state,
                unreadQuestions: 0,
            };
            break;
    }

    if (previous != state) {
        if (previous.listed != state.listed) {
            state = set(
                'listed',
                _(state.listed)
                    .map((question, i) => {
                        // console.log(i, question);
                        // Anonymize questions
                        if (question.anonymous && !question._anonimized) {
                            return Object.assign({}, question, {
                                _anonimized: true,
                                _origAsker: question.asker,
                                asker: Object.assign({}, question.asker, ANONYMOUS),
                            });
                        }
                        return question;
                    })
                    .map((question) => {
                        // Anonymize answers
                        if (!question.answers._anonimized) {
                            question = set('answers._anonimized', true, question);
                            question = set(
                                'answers.data',
                                _(question.answers.data)
                                    .map((answer) => {
                                        if (answer.anonymous && !answer._anonimized) {
                                            answer = Object.assign({}, answer, {
                                                _anonimized: true,
                                                _origAnswerer: answer.answerer,
                                                answerer: Object.assign({}, answer.answerer, ANONYMOUS),
                                            });
                                        }
                                        return answer;
                                    })
                                    .value(),
                                question
                            );
                        }
                        return question;
                    })
                    .value(),
                state
            );
        }

        // Set indexed container
        state = set(
            'indexed',
            _(state.listed).reduce((indexed, q) => {
                indexed[q.id] = q;
                return indexed;
            }, {}),
            state
        );
    }

    return state;
}
